import React from 'react';
import PropTypes from 'prop-types';

import { msg } from 'api';
import ProductLabel from 'apps/products/models/ProductLabel';

export default function OutOfStockInfo(props) {
  const { productLabels } = props;

  return (productLabels && productLabels.includes(ProductLabel.OOS))
    ? <span className="oos-info">{msg.common.msg.outOfStock}</span>
    : null;
}

OutOfStockInfo.propTypes = {
  productLabels: PropTypes.arrayOf(PropTypes.oneOf(Object.values(ProductLabel))),
};
